export default __webpack_public_path__ + "static/1-cf2f4a6add6b8f9ca13412b8c5a71727.webp";